"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

require("./Container.scss");

var _excluded = ["children", "width", "fixed", "align", "debug", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  /** Content of the component */
  children: _propTypes.node,

  /** Choose between these widths. They correspond to mq-breakpoints: */
  width: (0, _propTypes.oneOf)(['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', 'full']),

  /** Non-reponsive container width */
  fixed: _propTypes.bool,

  /** Align container using auto margins */
  align: (0, _propTypes.oneOf)(['left', 'center', 'right']),

  /** Show visual grid guidelines */
  debug: _propTypes.bool,

  /** Optional custom classes. They will be merged with `componentClasses` */
  className: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.array])
};
var defaultProps = {
  align: 'center',
  debug: false
};
/** The Container limits content to a maximum width. It is most often used to
 * hold grid rows, columns and components.
 * @visibleName Grid Container
 * */

var Container = function Container(_ref) {
  var children = _ref.children,
      width = _ref.width,
      fixed = _ref.fixed,
      align = _ref.align,
      debug = _ref.debug,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var componentClassNames = (0, _classnames.default)('rds-container', {
    'rds-container--xxs': width === 'xxs',
    'rds-container--xs': width === 'xs',
    'rds-container--s': width === 's',
    'rds-container--m': width === 'm',
    'rds-container--l': width === 'l',
    'rds-container--xl': width === 'xl',
    'rds-container--xxl': width === 'xxl',
    'rds-container--left': align === 'left',
    'rds-container--center': align === 'center',
    'rds-container--right': align === 'right',
    'rds-container--fixed': fixed,
    'rds-container--guides': debug
  }, className);
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: componentClassNames
  }, rest), children);
};

Container.propTypes = propTypes;
Container.defaultProps = defaultProps;
var _default = Container;
exports.default = _default;